import { format, type Locale } from 'date-fns';
import ruLocale from 'date-fns/locale/ru';
import { DateTime } from 'luxon';
import { useEffect, useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { LocalizationProvider, MobileDateTimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useMobile } from '@shared/hooks/index.ts';
import * as st from './styles.module.scss';

const customRuLocale = {
  ...ruLocale,
  localize: {
    ...ruLocale.localize,
    month: (i: number) => {
      const months = [
        'янв',
        'фев',
        'мар',
        'апр',
        'май',
        'июн',
        'июл',
        'авг',
        'сент',
        'окт',
        'нояб',
        'дек',
      ];
      return months[i];
    },
  },
} as Locale;
type PT = {
  id: number;
  index: number;
};
export const Schedule = ({ id, index }: PT) => {
  const { watch, setValue } = useFormContext();

  const programVideos = watch('exercises');
  const schedules = watch('schedules');

  const [selectedDate, setSelectedDate] = useState<Date>(() => {
    const stringDate = schedules?.at(index)?.date;

    // преобразование в дату
    const parsed = stringDate ? DateTime.fromFormat(stringDate, "yyyy-MM-dd'T'HH:mm:ssZZ") : null;

    return parsed?.isValid ? parsed.toJSDate() : new Date();
  });
  const [open, setOpen] = useState(false);
  const pillRef = useRef<HTMLDivElement>(null);
  const { isMobile } = useMobile();

  useEffect(() => {
    setValue(`schedules.${index}`, {
      // преобразование в нужный бекенду вид
      date: DateTime.fromJSDate(selectedDate).toFormat("yyyy-MM-dd'T'HH:mm:ssZZ"),
      videoId: id,
    });
  }, [selectedDate, programVideos]);

  const commonPickerProps = {
    open,
    onClose: () => setOpen(false),
    onAccept: () => setOpen(false),
    value: selectedDate,
    onChange: (d: Date | null) => d && setSelectedDate(d),
    format: 'dd/MM/yyyy в HH:mm',
    views: ['month', 'day', 'hours', 'minutes'] as const,
    slots: { textField: () => null },
    timeSteps: { minutes: 1 },
    // локализация тулбара и кнопок
    localeText: {
      // заголовок тулбара
      dateTimePickerToolbarTitle: 'Укажите дату и время',
      // кнопка «Отмена»
      cancelButtonLabel: 'Отмена',
      // кнопка «ОК»
      okButtonLabel: 'Готово',
    },
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={customRuLocale}>
      {/*плашка*/}
      <div
        className={st.wrapper}
        onClick={(e) => {
          isMobile && e.stopPropagation();
        }}
      >
        <p className={st.mobileLabel}>Доступно с</p>
        <div
          className={st.field}
          ref={pillRef}
          onClick={() => {
            setOpen(true);
          }}
        >
          <p>{format(selectedDate, 'dd.MM.yyyy', { locale: customRuLocale })}</p>
          <div className={st.divider}></div>
          <p>{format(selectedDate, 'HH:mm', { locale: customRuLocale })}</p>
        </div>
        {/* Сам DateTimePicker */}
        {/*{isMobile ? (*/}
        <MobileDateTimePicker
          {...commonPickerProps}
          slotProps={{
            mobilePaper: {
              sx: {
                width: '100%',
                maxWidth: '640px',
                margin: '30px',
                borderRadius: '10px',
              },
            },
            tabs: {
              sx: {
                display: 'none',
              },
            },
            actionBar: {
              actions: ['accept'], // убираем 'отмена'
            },
          }}
        />
        {/*) : (*/}
        {/*  <DesktopDateTimePicker*/}
        {/*    {...commonPickerProps}*/}
        {/*    slotProps={{*/}
        {/*      popper: {*/}
        {/*        anchorEl: pillRef.current,*/}
        {/*        placement: 'bottom-start',*/}
        {/*      },*/}
        {/*    }}*/}
        {/*  />*/}
        {/*)}*/}
      </div>
    </LocalizationProvider>
  );
};
